/* eslint-disable max-len */
import { useState } from 'react';

import arrowIcon from 'assets/images/arrow-down@3x.png';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';

import ProductModal from 'settings/product-listing/components/ProductModal';
import SearchContainer from 'stocks/components/common/Search';

import CN from './HeaderStocksFilter.module.scss';

const HeaderStocksFilter = ({
  salonId,
  additionalClass = '',
  cssPosition,
  hasAnyProducts,
  selectedBrandCount,
  selectedSubBrandCount,
  selectedCategoryCount,
  showFilterByBrand,
  showFilterBySubBrand,
  showFilterByCategory,
  clearFilter,
  showLowProducts,
  lowInStock,
  onCheckLowInStock,
  onSearch,
  search,
  clearSearch,
  clearBtn,
  useProductModal,
  jsPdfGenerator,
  children,
}) => {
  const [addProductModal, setAddProductModal] = useState(false);

  const { t } = useTranslation();

  const addProduct = () => setAddProductModal(true);
  const cancelAddProduct = () => setAddProductModal(false);

  return (
    <>
      {addProductModal && (
        <div className="container-product-modal">
          <div className="overlay" role="button" tabIndex={0} onClick={cancelAddProduct} />
          <ProductModal
            popupTitle={t('stocks.managerLayout.addProductModal.title')}
            formType="create"
            cancel={cancelAddProduct}
            salonId={salonId}
          />
        </div>
      )}
      <div className={`stocks-filter-bar ${additionalClass ? additionalClass : ''}`}>
        <div className="scroll-bar">
          <div className={`scroll-content ${cssPosition}`}>
            {children}
            <div className="brand-filter-buttons">
              {hasAnyProducts && (
                <>
                  <span className="filter-label">{t('stocks.managerLayout.headerFilters.filters')}</span>
                  <span
                    className={
                      selectedBrandCount && selectedBrandCount >= 1 ? 'filter-by-brand selected' : 'filter-by-brand'
                    }
                    role="button"
                    tabIndex={0}
                    onClick={showFilterByBrand}
                  >
                    {selectedBrandCount && <span className="selected-count">{selectedBrandCount}</span>}
                    {t('stocks.managerLayout.headerFilters.brand')}
                    <img src={arrowIcon} alt="Dropdown icon" />
                  </span>
                  <span className="brand-label">{t('stocks.managerLayout.headerFilters.and')}</span>
                  <span
                    className={
                      selectedSubBrandCount && selectedSubBrandCount >= 1
                        ? 'filter-by-sub-brand selected'
                        : 'filter-by-sub-brand'
                    }
                    role="button"
                    tabIndex={0}
                    onClick={showFilterBySubBrand}
                  >
                    <span className="selected-count">{selectedSubBrandCount}</span>
                    {t('stocks.managerLayout.headerFilters.subBrand')}
                    <img src={arrowIcon} alt="" />
                  </span>
                  <span className="brand-label">{t('stocks.managerLayout.headerFilters.and')}</span>
                  <span
                    className={
                      selectedCategoryCount && selectedCategoryCount >= 1
                        ? 'filter-by-category selected'
                        : 'filter-by-category'
                    }
                    role="button"
                    tabIndex={0}
                    onClick={showFilterByCategory}
                  >
                    <span className="selected-count">{selectedCategoryCount}</span>
                    {t('stocks.managerLayout.headerFilters.category')}
                    <img src={arrowIcon} alt="" />
                  </span>
                </>
              )}
            </div>
            <div className="clear-filter">
              <Button variant="secondary" onClick={clearFilter}>
                <span className={CN.nowrap}> {t('stocks.managerLayout.headerFilters.clearFilter')}</span>
              </Button>
            </div>

            {showLowProducts && (
              <div className="position-container">
                <div className="checkbox-box-custom-wrap" id="stocks-cb">
                  <input
                    type="checkbox"
                    className="checkbox-box-custom"
                    id="cb1"
                    checked={lowInStock}
                    onChange={onCheckLowInStock}
                  />
                  <label className="checkbox-box-label" htmlFor="cb1">
                    {t('stocks.managerLayout.headerFilters.showLowStock')}
                    <div className="checkbox-box-custom-icon">
                      <span className="ic-sml-18px ic_check_white_18" />
                    </div>
                  </label>
                </div>
              </div>
            )}

            {hasAnyProducts && onSearch && (
              <SearchContainer
                currentText={search}
                onTextChange={onSearch}
                clearSearch={clearSearch}
                clearBtn={clearBtn}
              />
            )}
            <div className={CN.buttonsContainer}>
              <Button variant="primary" width="medium" onClick={addProduct}>
                <span className={CN.nowrap}>{t('stocks.managerLayout.headerFilters.addProductButton')}</span>
              </Button>
              <Button variant="emphasis" width="medium" onClick={useProductModal}>
                <span className={CN.nowrap}> {t('stocks.managerLayout.headerFilters.useProductButton')}</span>
              </Button>
              <Button variant="icon" width="small" onClick={jsPdfGenerator}>
                <Icon variant="download" width="lg" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderStocksFilter;
